import { useEffect } from "react";

const BdeCourseRedirect = () => {
  useEffect(() => {
    window.location.href = "https://wa.me/14164779616?text=Hi%20VLI%20I%20want%20to%20enroll"; // your WhatsApp number
  }, []);

  return null;
};

export default BdeCourseRedirect;